import DashboardService from "../../api/dashboardService";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {WishType} from "../wish/Helper";

export const getCategoriesPopularityPlot =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getCategoriesPopularityPlot`,
        async (req: { categoryIds: string[], wishType: WishType }, thunkAPI) => {
            try {
                const res = await DashboardService.fetchCategoriesPopularityPlot(req.categoryIds, req.wishType)
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getTotalTicketsPlot =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getTotalTicketsPlot`,
        async (req: { startDate: string, endDate: string, wishType: WishType }, thunkAPI) => {
            try {
                const res = await DashboardService.fetchTotalTicketsPlot(req.startDate, req.endDate, req.wishType)
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getClientsTotalTicketsPlot =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getClientsTotalTicketsPlot`,
        async (req: { startDate: string, endDate: string, wishType: WishType }, thunkAPI) => {
            try {
                const res = await DashboardService.fetchClientTotalTicketsPlot(req.startDate, req.endDate, req.wishType)
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getUsersPerMonthPlot =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getUsersPerMonthPlot`,
        async (req: { startDate: string, endDate: string }, thunkAPI) => {
            try {
                const res = await DashboardService.fetchUsersPerMonthPlot(req.startDate, req.endDate)
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getPayingUsersPerMonthPlot =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getPayingUsersPerMonthPlot`,
        async (req: { startDate: string, endDate: string }, thunkAPI) => {
            try {
                const res = await DashboardService.fetchPayingUsersPerMonthPlot(req.startDate, req.endDate)
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getExpensesPerMonth =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getExpensesPerMonth`,
        async (req: { startDate: string, endDate: string }, thunkAPI) => {
            try {
                const res = await DashboardService.fetchExpensesPerMonthPlot(req.startDate, req.endDate)
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getTicketsPerMonthPlot =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getTicketsPerMonthPlot`,
        async (req: { startDate: string, endDate: string, wishType: WishType }, thunkAPI) => {
            try {
                const res = await DashboardService.fetchTicketsPerMonthPlot(req.startDate, req.endDate, req.wishType)
                return {data: res.data, type: req.wishType}
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getWishPopularityPerCost =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getWishPopularityPerVoucherCost`,
        async (wishType: WishType, thunkAPI) => {
            try {
                const res = await DashboardService.fetchWishPopularityPerCost(wishType)
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getWishPopularityPerPointsAward =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getWishPopularityPerPointsAward`,
        async (_, thunkAPI) => {
            try {
                const res = await DashboardService.fetchWishPopularityPerPointsAward()
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getWishPopularityPerPointsAwardForClient =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getWishPopularityPerPointsAwardForClient`,
        async (_, thunkAPI) => {
            try {
                const res = await DashboardService.fetchWishPopularityPerPointsAwardForClient()
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getUsersCountPerGender =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getUsersCountPerGender`,
        async (_, thunkAPI) => {
            try {
                const res = await DashboardService.fetchUsersCountPerGender()
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getExpensesPerCategory =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getExpensesPerCategory`,
        async (_, thunkAPI) => {
            try {
                const res = await DashboardService.fetchExpensesPerCategory()
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getClientTickets =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getClientTickets`,
        async (wishType: WishType, thunkAPI) => {
            try {
                const res = await DashboardService.fetchClientTickets(wishType)
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getClientTicketsPerWish =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getClientTicketsPerWish`,
        async (wishType: WishType, thunkAPI) => {
            try {
                const res = await DashboardService.fetchClientTicketsPerWish(wishType)
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })


export const getClientProfitPerMonth =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getClientProfitPerMonth`,
        async (_, thunkAPI) => {
            try {
                const res = await DashboardService.fetchClientProfitPerMonth()
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getAdminProfitPerMonth =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getAdminProfitPerMonth`,
        async (req: { startDate: string, endDate: string }, thunkAPI) => {
            try {
                const res = await DashboardService.fetchAdminProfitPerMonth(req.startDate, req.endDate)
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getAdminIncomePerDayLast30Days =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getAdminIncomePerDayLast30Days`,
        async (_, thunkAPI) => {
            try {
                const res = await DashboardService.fetchAdminIncomePerDayLast30Days()
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getAdminNetProfitPerMonth =
    createAsyncThunk(`${SliceNames.DASHBOARD}/getAdminNetProfitPerMonth`,
        async (req: { startDate: string, endDate: string }, thunkAPI) => {
            try {
                const res = await DashboardService.fetchAdminNetProfitPerMonth(req.startDate, req.endDate)
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })
